import {useEffect} from 'react';
import { useHelpContext } from './Provider';
import { useSyncedPreference } from '../../Data/Preference';
import { useSession } from '../Session';
import API from '../../Services/API';

const Freshchat = () => {

    const {user} = useSession();
    const {setUnreadMessages, setLiveChatCallback} = useHelpContext();
    const [restoreId, setRestoreId, isLoadingRestoreId] = useSyncedPreference('freshchatRestoreId', null);

    useEffect(() => {
        if (document.getElementById('freshchat-js') === null) {
            const link = document.createElement('script');
            link.src = 'https://wchat.eu.freshchat.com/js/widget.js';
            link.id = 'freshchat-js';
            link.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(link);

            link.addEventListener('load', (e) => {
                window.fcWidget.on('user:created', (resp) => {
                    const status = resp && resp.status,
                        data = resp && resp.data;

                    if (status === 200 && data?.restoreId) {
                        setRestoreId(data.restoreId);
                    }
                });

                initFreshchat(user, setUnreadMessages, isLoadingRestoreId, restoreId)
            })
        }

        initFreshchat(user, setUnreadMessages, isLoadingRestoreId, restoreId)

        // Return the unsubscribe function
        return setLiveChatCallback(() => toggleLiveChat());

        // eslint-disable-next-line
    }, [user, isLoadingRestoreId]);

    return null;
}

const toggleLiveChat = () => {
    if (window.fcWidget.isOpen()) {
        window.fcWidget.close()
    } else {
        window.fcWidget.open()
    }
}

const initFreshchat = (user, setUnreadMessages, isLoadingRestoreId, restoreId) => {
    if (API.isAdminSwitchedBusiness()) {
        console.warn('Not initialising Freshchat as admin is switched to a business');
        return;
    }

    if (!user || !window.fcWidget || isLoadingRestoreId) {
        return;
    }

    if (window.fcWidget.isInitialized() === true) {
        return;
    }

    window.fcWidget.on("unreadCount:notify", (resp) => setUnreadMessages(parseInt(resp.count)));

    window.fcWidget.init({
        token: "4c4c8894-1b17-495f-a990-ce6111844e32",
        host: "https://wchat.eu.freshchat.com",

        externalId: user.id,
        restoreId: restoreId,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        // phone: user.phoneNumber,

        config: {
            headerProperty: {
                hideChatButton: true
            },
            disableNotifications: true
        },
        open: false
    });

    window.fcWidget.user.setProperties({
        externalId: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
    });

}


export default Freshchat;
